import { IDetailPageData } from "../../../shared/utils/api";

export interface IProcessTypeStageAction{
  id: string;
  name: string;
  action_type: string;
  to_perform: string;
  selected_action_id: string;
}

export interface IProcessTypeStageUserGroup {
  id: string;
  user_group_id: string;
  user_group_name: string;
}

export interface IProcessTypeStage {
  id: string;
  domain_stage_id: string;
  domain_stage_name: string;
  domain_stage_position: number;
  process_type_id: string;
  process_type_stage_actions: IProcessTypeStageAction[];
  process_type_stage_user_groups: IProcessTypeStageUserGroup[];
  mandatory: boolean;
}

export interface IProcessType {
  id: string;
  name: string;
  active: boolean;
  domain_type_id: string;
  consolidate_on_entity_id: string;
  consolidate_on_entity_name: string;
  event_capture_screen_id: string;
  event_capture_screen_name: string;
  consolidate_display_field_id: string;
  consolidate_display_field_name: string;
  consolidation_timeframe: number;
  process_type_id: string;
  process_type_stages: IProcessTypeStage[];
}

export interface IBackendProcessType {
  id: string;
  name: string;
  active: boolean;
  domain_type_id: string;
  consolidate_on_entity_id: string;
  event_capture_screen_id: string;
  consolidate_display_field_id: string;
  consolidation_timeframe: number;
  process_type_id: string;
  process_type_stages: IProcessTypeStage[];
}

export function transformToBackendProcessType(data: any): IBackendProcessType { // eslint-disable-line
  return {
    id: data.id,
    name: data.name,
    active: data.active,
    domain_type_id: data.domain_type_id,
    consolidate_on_entity_id: data.consolidate_on_entity_id,
    event_capture_screen_id: data.event_capture_screen_id,
    consolidation_timeframe: data.consolidation_timeframe === "" ? undefined : data.consolidation_timeframe,
    process_type_id: data.process_type_id,
    consolidate_display_field_id: data.consolidate_display_field_id,
    process_type_stages: data.process_type_stages.map((processTypeStage: any) => ({ // eslint-disable-line
      id: processTypeStage.id,
      mandatory: processTypeStage.mandatory,
      domain_stage_id: processTypeStage.domain_stage_id,
      process_type_stage_user_groups: processTypeStage.process_type_stage_user_groups.map((userGroup: any) => ({ // eslint-disable-line
        id: userGroup.id,
        user_group_id: userGroup.user_group_id
      })),
      process_type_stage_actions: processTypeStage.process_type_stage_actions.map((action: any) => ({ // eslint-disable-line
        id: action.id,
        action_type: action.action_type,
        selected_action_id: action.selected_action_id
      }))
    }))
  };
}

export function transformFromBackendProcessType(backendType: IProcessType): IDetailPageData {
  return {
    rowData: [],
    id: backendType.id,
    name: backendType.name,
    active: backendType.active,
    domain_type_id: backendType.domain_type_id,
    consolidate_on_entity_id: backendType.consolidate_on_entity_id,
    consolidate_on_entity_name: backendType.consolidate_on_entity_name,
    event_capture_screen_id: backendType.event_capture_screen_id,
    event_capture_screen_name: backendType.event_capture_screen_name,
    consolidate_display_field_id: backendType.consolidate_display_field_id,
    consolidate_display_field_name: backendType.consolidate_display_field_name,
    consolidation_timeframe: backendType.consolidation_timeframe === null ? undefined : backendType.consolidation_timeframe,
    process_type_id: backendType.process_type_id,
    process_type_stages: backendType.process_type_stages.map((processTypeStage: any) => ({ // eslint-disable-line
      id: processTypeStage.id,
      mandatory: processTypeStage.mandatory,
      domain_stage_id: processTypeStage.domain_stage_id,
      domain_stage_name: processTypeStage.domain_stage_name,
      domain_stage_position: processTypeStage.domain_stage_position,
      process_type_id: processTypeStage.process_type_id,
      process_type_stage_actions: processTypeStage.process_type_stage_actions.map((action: any) => ({ // eslint-disable-line
        id: action.id,
        name: action.name,
        action_type: action.action_type,
        selected_action_id: action.selected_action_id,
        to_perform: action.to_perform
      })),
      process_type_stage_user_groups: processTypeStage.process_type_stage_user_groups.map((userGroup: any) => ({ // eslint-disable-line
        id: userGroup.id,
        user_group_id: userGroup.user_group_id,
        user_group_name: userGroup.user_group_name
      }))
    }))
  };
}